var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-card',{staticClass:"m-3",attrs:{"shadow":"never"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }